import React, { useEffect, useRef } from 'react';
import './Disribution.css';
import distributionImage from '../../assets/images/frame2.svg';

const Distribution = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Add animation classes when component comes into view
                        const title = entry.target.querySelector('.distribution-title');
                        const description = entry.target.querySelector('.distribution-description');
                        const image = entry.target.querySelector('.distribution-img');

                        if (title) {
                            title.classList.add('animate-fade-in-left');
                        }
                        if (description) {
                            description.classList.add('animate-fade-in-left', 'delay-200');
                        }
                        if (image) {
                            image.classList.add('animate-fade-in-right', 'delay-400');
                        }

                        // Unobserve after animation is triggered
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.3, // Trigger when 30% of the component is visible
                rootMargin: '0px 0px -50px 0px'
            }
        );

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
            }
        };
    }, []);

    return (
        <div className="distribution-container" ref={containerRef}>
            <div className="distribution-content">
                <div className="distribution-text">
                    <h2 className="distribution-title">Effortless Asset <span className="distribution-title-span">Distribution</span></h2>
                    <p className="distribution-description">
                        Share assets securely across platforms, teams, or campaigns — all while retaining control and usage insights.
                    </p>
                </div>
                <div className="distribution-image">
                    <img 
                        src={distributionImage}
                        alt="Effortless Asset Distribution" 
                        className="distribution-img"
                    />
                </div>
            </div>
        </div>
    )
}

export default Distribution;